module.exports = __webpack_public_path__ + "static/media/Alba soffa 2,5-sits öppet avslut tyg Aragon light grey detalj 2024 9.fc7fde4c.jpg";